import React, { useState } from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { Box } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../Axios"; // Adjust path as needed

const raasiList = [
  "Mesham",
  "Rishabam",
  "Midhunam",
  "Kadagam",
  "Simmam",
  "Kanni",
  "Thulam",
  "Viruchigam",
  "Dhanus",
  "Magaram",
  "Kumbam",
  "Meenam",
];

const starList = [
  "ashwini",
  "barani",
  "krithikai",
  "rohini",
  "mirugasiridam",
  "thiruvadhirai",
  "punarpoosam",
  "poosam",
  "ayilyam",
  "magam",
  "pooram",
  "uthiram",
  "astham",
  "chithirai",
  "swathi",
  "visagam",
  "anusham",
  "kettai",
  "mulam",
  "puradam",
  "uthiradam",
  "thiruvonam",
  "avittam",
  "sadayam",
  "purattadhi",
  "uttrttadhi",
  "revathi",
];

const dhosamList = [
  "No Dhosam",
  "Chevvai Dhosam",
  "Rahu Kethu Dhosam",
  "Rahu Kethhu, Chevvai Dhosam",
];

const AddHoroscope = () => {
  const { id } = useParams(); // userId from route
  const history = useHistory();

  const [data, setData] = useState({
    raasi: "",
    star: "",
    dhosam: "", // Changed from array to string for radio button
    horoNecessary: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData({ ...data, [name]: type === "checkbox" ? checked : value });
  };

  // Simplified handler for radio button
  const handleDhosamChange = (value) => {
    setData({ ...data, dhosam: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: id,
      ...data,
      horoNecessary: data.horoNecessary ? true : false,
    };

    api
      .post("/admin/userProfile/userHoroscope/", payload)
      .then((res) => {
        Swal.fire("Success", "Horoscope saved successfully", "success");
        history.push(`/addimage/${id}`);
      })
      .catch((err) => {
        Swal.fire(
          "Error",
          (err && err.message) || "Something went wrong",
          "error"
        );
      });
  };

  const labelStyle = {
    fontWeight: "bold",
    color: "#333",
    marginBottom: 6,
  };

  const inputStyle = {
    border: "1.5px solid grey",
    borderRadius: 6,
    padding: "8px 10px",
    fontWeight: "bold",
    color: "#333",
  };

  return (
    <>
      <div
        style={{
          background: "#fff",
          borderRadius: 8,
          padding: 20,
          margin: "100px 10px 20px 10px",
        }}
      >
        <h4
          style={{ fontWeight: "bold", color: "#1a237e", fontSize: "1.5rem" }}
        >
          Add Horoscope
        </h4>
      </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
        <Box>
          <FormGroup>
            <Label htmlFor="raasi" style={labelStyle}>
              Raasi
            </Label>
            <Input
              type="select"
              name="raasi"
              id="raasi"
              value={data.raasi}
              onChange={handleChange}
              required
              style={inputStyle}
            >
              <option value="" disabled hidden>
                Select
              </option>
              {raasiList.map((x) => (
                <option key={x} value={x}>
                  {x}
                </option>
              ))}
            </Input>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="star" style={labelStyle}>
              Star
            </Label>
            <Input
              type="select"
              name="star"
              id="star"
              value={data.star}
              onChange={handleChange}
              required
              style={inputStyle}
            >
              <option value="" disabled hidden>
                Select
              </option>
              {starList.map((x) => (
                <option key={x} value={x}>
                  {x}
                </option>
              ))}
            </Input>
          </FormGroup>

          <FormGroup>
            <Label style={labelStyle}>Dhosam</Label>
            {dhosamList.map((x, index) => (
              <div
                key={index}
                onClick={() => handleDhosamChange(x)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: data.dhosam === x ? "2px solid #000000" : "2px solid #ccc",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  backgroundColor: "#f9f9f9",
                }}
              >
                {/* Custom Radio Circle */}
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    border: data.dhosam === x ? "2px solid #000000" : "2px solid #999",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    marginRight: "12px",
                  }}
                >
                  {data.dhosam === x && (
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {/* Tick mark */}
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 10.5L3.5 8L2.5 9L6 12.5L14 4.5L13 3.5L6 10.5Z"
                          fill="#000000"
                        />
                      </svg>
                    </div>
                  )}
                </div>

                <input
                  type="radio"
                  id={`dhosam-${index}`}
                  name="dhosam"
                  value={x}
                  checked={data.dhosam === x}
                  onChange={() => handleDhosamChange(x)}
                  style={{ display: "none" }}
                />
                <label
                  htmlFor={`dhosam-${index}`}
                  style={{
                    fontSize: "15px",
                    fontWeight: data.dhosam === x ? "600" : "500",
                    cursor: "pointer",
                    color: data.dhosam === x ? "#000000" : "#333",
                    userSelect: "none",
                    margin: 0,
                  }}
                >
                  {x}
                </label>
              </div>
            ))}
          </FormGroup>
          <FormGroup>
            <Label style={labelStyle}>Horoscope Necessary</Label>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={() =>
                handleChange({
                  target: {
                    name: "horoNecessary",
                    value: !data.horoNecessary,
                  },
                })
              }
            >
              <div
                style={{
                  width: "50px",
                  height: "26px",
                  borderRadius: "13px",
                  backgroundColor: data.horoNecessary ? "#000000" : "#ccc",
                  position: "relative",
                  transition: "background-color 0.3s ease",
                  marginRight: "10px",
                }}
              >
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    position: "absolute",
                    top: "2px",
                    left: data.horoNecessary ? "26px" : "2px",
                    transition: "left 0.3s ease",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                  }}
                />
              </div>
              <span style={{ fontSize: "15px", fontWeight: "500" }}>
                {data.horoNecessary ? "On" : "Off"}
              </span>
            </div>
          </FormGroup>


          <Button
            style={{
              width: "30%",
              borderRadius: 8,
              backgroundColor: "#000",
              color: "#fff",
              fontWeight: "bold",
              padding: "10px 0",
              marginTop: "20px",
            }}
            type="submit"
          >
            Save & Continue
          </Button>
        </Box>
      </Form>
    </>
  );
};

export default AddHoroscope;